import { useThemePalette } from "common/hooks/theme_palette";
import { Stack, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function FormActions({ handleClose, refsubmit }) {
  const { oliveGreen } = useThemePalette();
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      justifyContent="center"
      gap={5}
      sx={{ borderTop: "1px solid #E2E2E2", py: 3 }}
    >
      <Button
        sx={{
          fontSize: "18px",
          color: "black",
          border: "1px solid",
          px: 6,
        }}
        onClick={handleClose}
      >
        {t("vendors.action_cancel")}
      </Button>
      <Button
        ref={refsubmit}
        type="submit"
        sx={{
          backgroundColor: oliveGreen,
          "&:hover": {
            backgroundColor: oliveGreen,
          },
          color: "white",
          fontSize: "18px",
          px: 5,
        }}
      >
        Save Details
      </Button>
    </Stack>
  );
}
